@for (blockId of blockIdList; track blockId; let index = $index) {
  <app-block-factory
    [blockId]="forceType(blockId)"
    [injectData]="injectData"
    (isVisibleChanged)="isVisibleChanged.emit({ isVisible: forceType($event), index })"
    *ngIf="blockVisibility[index] === undefined || blockVisibility[index] === true"
  />
}
